import { render, staticRenderFns } from "./EditChildActivityConfigDialog.vue?vue&type=template&id=66dd6468&scoped=true"
import script from "./EditChildActivityConfigDialog.vue?vue&type=script&lang=js"
export * from "./EditChildActivityConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./EditChildActivityConfigDialog.vue?vue&type=style&index=0&id=66dd6468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd6468",
  null
  
)

export default component.exports